var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role summerypage"
  }, [_c('div', {
    staticClass: "header-block"
  }, [(_vm.titledisable) ? _c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Shipments Search ")])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisable) ? _c('div', {
    staticClass: "awb"
  }, [_c('span', {
    staticClass: "back-arrow",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('svg', {
    attrs: {
      "stroke": "currentColor",
      "fill": "currentColor",
      "stroke-width": "0",
      "viewBox": "0 0 512 512",
      "height": "1em",
      "width": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "48",
      "d": "M244 400L100 256l144-144M120 256h292"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('div', {
    staticClass: "steps"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "step",
      on: {
        "click": function($event) {
          _vm.scrollToSection('section' + (index + 1))
        }
      }
    }, [_c('div', {
      staticClass: "step-number"
    }, [_vm._v(_vm._s(_vm.formatNumber(index + 1)))]), _vm._v(" "), _c('div', {
      staticClass: "step-content"
    }, [_c('div', {
      staticClass: "step-label"
    }, [_vm._v(_vm._s(step.label))]), _vm._v(" "), _c('div', {
      staticClass: "step-dots"
    }, [_vm._v("...")])])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper"
  }, [_c('section', {
    staticClass: "section",
    attrs: {
      "id": "search-section"
    }
  }, [_c('div', {
    staticClass: "section-header"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.awbnumber),
      expression: "awbnumber",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "AWB",
      "name": "awbnumber",
      "placeholder": "Enter The Shipping ID",
      "type": "text",
      "inputmode": "numeric",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.searchLoading
    },
    on: {
      "click": function($event) {
        _vm.getSummeryData()
      }
    }
  }, [_vm._v("Search "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)])])]), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("AWB No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.ShippingID ? _vm.summeryData.ShippingID : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("MPS No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.ShippingID ? _vm.summeryData.ShippingID : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Octroi MRP")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.OctroiMRP ? '₹ ' + _vm.number_format(_vm.summeryData.OctroiMRP) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.bagShipmentSummery.NetPayment ? '₹ ' + _vm.number_format(_vm.bagShipmentSummery.NetPayment) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("COD Payment")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.bagShipmentSummery.CODPayment ? '₹ ' + _vm.number_format(_vm.bagShipmentSummery.CODPayment) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.VolWeight ? _vm.summeryData.VolWeight + ' kgs' : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PhyWeight ? _vm.summeryData.PhyWeight + ' kgs' : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.BillableWeight ? _vm.summeryData.BillableWeight + ' kgs' : '-') + " ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment L * B * H")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.Length ? _vm.summeryData.Length : '0') + " "), _c('span', [_vm._v("×")]), _vm._v(" " + _vm._s(_vm.summeryData.Width ? _vm.summeryData.Width : '0') + " "), _c('span', [_vm._v("×")]), _vm._v(" " + _vm._s(_vm.summeryData.Height ? _vm.summeryData.Height : '0') + " cm")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("(Reason For Return) Instructions")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.Instruction ? _vm.summeryData.Instruction : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Total Items")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.TotalItems ? _vm.summeryData.TotalItems : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.RTODetails ? (_vm.summeryData.RTODetails.rtoName ? _vm.summeryData.RTODetails.rtoName : '-') : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO Address")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.RTODetails ? (_vm.summeryData.RTODetails.rtoAddress ? _vm.summeryData.RTODetails.rtoAddress : '-') : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO PinCode")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.RTODetails ? (_vm.summeryData.RTODetails.rtoPincode ? _vm.summeryData.RTODetails.rtoPincode : '-') : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO City")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.RTODetails ? (_vm.summeryData.RTODetails.rtoCity ? _vm.summeryData.RTODetails.rtoCity : '-') : '-'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section2"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.ProductName ? _vm.summeryData.ProductDetails.ProductName : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Product Qty")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.ProductQty ? _vm.summeryData.ProductDetails.ProductQty : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Product Description ")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.ProductDescription ? _vm.summeryData.ProductDetails.ProductDescription : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Images")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.PickupProductImage) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.summeryData.ProductDetails.PickupProductImage), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.summeryData.ProductDetails.PickupProductImage, i, 'Manifestation Images')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img.ImageUrl,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])])]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "section-content mt-3"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Business Unit")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.BusinessType ? _vm.summeryData.BusinessType : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.ServiceType ? _vm.summeryData.ServiceType : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Client Name / ID ")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.clienList[_vm.summeryData.ClientId] ? _vm.clienList[_vm.summeryData.ClientId] : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("WH POID ")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.RTODetails ? (_vm.summeryData.RTODetails.rtoPincode ? _vm.summeryData.RTODetails.rtoPincode : '-') : '-'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.summeryData.BusinessFlow == 'Reverse' && _vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section3"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropname ? _vm.summeryData.DropDetails.dropname : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropaddress ? _vm.summeryData.DropDetails.dropaddress : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment City")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropcity ? _vm.summeryData.DropDetails.dropcity : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment State")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropstate ? _vm.summeryData.DropDetails.dropstate : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Mobile No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropphoneno ? _vm.summeryData.DropDetails.dropphoneno : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Alternative Address")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropsecondaryaddress ? _vm.summeryData.DropDetails.dropsecondaryaddress : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Alternative Mobile No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.dropsecondaryphoneno ? _vm.summeryData.DropDetails.dropsecondaryphoneno : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment PinCode")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DropDetails.droppincode ? _vm.summeryData.DropDetails.droppincode : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipping Date")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.bagShipmentSummery.CreatedDate ? _vm.date_format(_vm.bagShipmentSummery.CreatedDate) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Courier Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s('-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipping Company")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s('-'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.summeryData.BusinessFlow == 'Forward' && _vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section3"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupname ? _vm.summeryData.PickupDetails.pickupname : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupaddress ? _vm.summeryData.PickupDetails.pickupaddress : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment City")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupcity ? _vm.summeryData.PickupDetails.pickupcity : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment State")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupstate ? _vm.summeryData.PickupDetails.pickupstate : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Mobile No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupphoneno ? _vm.summeryData.PickupDetails.pickupphoneno : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Alternative Address")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupsecondaryaddress ? _vm.summeryData.PickupDetails.pickupsecondaryaddress : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Alternative Mobile No")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickupsecondaryphoneno ? _vm.summeryData.PickupDetails.pickupsecondaryphoneno : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("LandLine")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s('-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment PinCode")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupDetails.pickuppincode ? _vm.summeryData.PickupDetails.pickuppincode : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipping Date")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.bagShipmentSummery.CreatedDate ? _vm.date_format(_vm.bagShipmentSummery.CreatedDate) : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Courier Name")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s('-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipping Company")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s('-'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section4"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Pickup Hub")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.hubList ? (_vm.hubList[_vm.summeryData.PickupHubId] ? _vm.hubList[_vm.summeryData.PickupHubId] : '-') : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Pickup SR ID")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PickupSRName ? _vm.summeryData.PickupSRName : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Pickup SR phone number")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.PickupSRMob ? _vm.summeryData.PickupSRMob : '-'))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper  wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("SR Images")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.srImagesArray.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.srImagesArray), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.srImagesArray, i, 'SR Images')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img.url,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("QC Questions")]), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper wide-item4"
  }, [_c('div', {
    staticClass: "content-data"
  }, [(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.clientQC.length > 0) ? _c('div', [_c('table', {
    staticClass: "qc-table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.summeryData.ProductDetails.clientQC), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "label"
    }, [_vm._v(_vm._s(data.Label))]), _vm._v(" "), _c('td', {
      staticClass: "values"
    }, [_vm._v(_vm._s(_vm.formatValueToCheck(data.ValueToCheck, data.Type)))]), _vm._v(" "), _c('td', {
      staticClass: "values"
    }, [_vm._v(_vm._s(_vm.getSRAnswer(data.Label, index)))])])
  }))])]) : _c('span', [_vm._v("-")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section5"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.ShipmentStatus ? _vm.summeryData.ShipmentStatus : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.Status ? _vm.summeryData.Status : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Notify Status")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.NotificationStatus ? _vm.summeryData.NotificationStatus : _vm.summeryData.NotificationType ? _vm.summeryData.NotificationType : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("PDD")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.PDD ? _vm.summeryData.PDD : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("No of Re attempts")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.summeryData.TotalAttemptcount ? _vm.summeryData.TotalAttemptcount : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("NDR")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.NDR ? _vm.summeryData.NDR : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("NPR")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.NPR ? _vm.summeryData.NPR : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Delivery SR")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.DeliverySRName ? _vm.summeryData.DeliverySRName : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Delivery Datetime")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.deliverydatetime ? _vm.summeryData.deliverydatetime : '-'))])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Hub Details")]), _vm._v(" "), _c('div', {
    staticClass: "section-content mt-4"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Origin Hub Name / ID")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_c('span', {
    class: _vm.hubList[_vm.summeryData.OriginHubId] != undefined && _vm.summeryData.OriginHubId ? 'name-list' : ''
  }, [_vm._v(_vm._s(_vm.hubList ? _vm.hubList[_vm.summeryData.OriginHubId] : '') + " ")]), _vm._v(" " + _vm._s(_vm.summeryData.OriginHubId ? _vm.summeryData.OriginHubId : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Origin Hub State / City")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.cityData[_vm.summeryData.OriginHubId] != undefined ? _vm.cityData[_vm.summeryData.OriginHubId] : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO Hub")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.summeryData.RTODetails && _vm.hubList[_vm.summeryData.RTODetails.rtoHubId] != undefined ? _vm.hubList[_vm.summeryData.RTODetails.rtoHubId] : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Current HUB Name / ID ")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_c('span', {
    class: _vm.hubList[_vm.summeryData.CurrentHubId] != undefined && _vm.summeryData.CurrentHubId ? 'name-list' : ''
  }, [_vm._v(_vm._s(_vm.hubList ? _vm.hubList[_vm.summeryData.CurrentHubId] : ''))]), _vm._v(" " + _vm._s(_vm.summeryData.CurrentHubId ? _vm.summeryData.CurrentHubId : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Current Hub State / City / Location")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_c('span', {
    class: _vm.cityData[_vm.summeryData.CurrentHubId] != undefined && _vm.hubList[_vm.summeryData.CurrentHubId] != undefined ? 'name-list' : ''
  }, [_vm._v(_vm._s(_vm.cityData ? _vm.cityData[_vm.summeryData.CurrentHubId] : '-'))]), _vm._v(" " + _vm._s(_vm.hubList ? _vm.hubList[_vm.summeryData.CurrentHubId] : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Destination Hub Name / ID")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_c('span', {
    class: _vm.hubList[_vm.summeryData.FinaldestinationId] != undefined && _vm.summeryData.FinaldestinationId ? 'name-list' : ''
  }, [_vm._v(_vm._s(_vm.hubList[_vm.summeryData.FinaldestinationId] != undefined ? _vm.hubList[_vm.summeryData.FinaldestinationId] : ''))]), _vm._v(" " + _vm._s(_vm.summeryData.FinaldestinationId ? _vm.summeryData.FinaldestinationId : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Final Hub State / City")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(_vm._s(_vm.cityData[_vm.summeryData.FinaldestinationId] != undefined ? _vm.cityData[_vm.summeryData.FinaldestinationId] : '-'))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section6"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "summary-table"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', [_vm._l((_vm.internalLogs), function(data, i) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.hubList[data.CurrentLocation] ? _vm.hubList[data.CurrentLocation] : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Process ? data.Process : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments ? data.Comments : '-') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedDate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(data.CreatedBy ? data.CreatedBy : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Actionstatuscode ? data.Actionstatuscode : '-'))])])
  }), _vm._v(" "), (_vm.internalLogs.length === 0) ? _c('tr', [_c('td', {
    staticClass: "no-data",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No data available")])]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section7"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("POD Image")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.podImage.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.podImage), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.podImage, i, 'POD Image')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img.url,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Sorter Image")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.getSorterImages.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.getSorterImages), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.getSorterImages, i, 'Sorter Image')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Investigation Images/Videos")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.assetsByExecutive.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.assetsByExecutive), function(media, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.assetsByExecutive, i, 'Investigation Image')
        }
      }
    }, [(_vm.isVideo(media.file)) ? _c('div', {
      staticClass: "video-container"
    }, [_c('video', {
      ref: "videoPlayers",
      refInFor: true,
      staticClass: "inv-video-preview",
      attrs: {
        "src": media.url,
        "type": "video/mp4",
        "controls": ""
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "play-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.togglePlayPause(i)
        }
      }
    }, [_vm._v("▶")])]) : _c('img', {
      staticClass: "media-preview",
      attrs: {
        "src": media.url,
        "alt": "Image Preview"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("TL QC Images")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.qcImagesFeching.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.qcImagesFeching), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.qcImagesFeching, i, 'TL QC Images')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("QC Image (by client)")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.summeryData.ProductDetails && _vm.summeryData.ProductDetails.PickupProductImage) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.summeryData.ProductDetails.PickupProductImage), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.summeryData.ProductDetails.PickupProductImage, i, 'QC Image (by client)')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img.ImageUrl,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("WHH and over OTP Verified Flag")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v(" " + _vm._s(_vm.WHHandoverOTPVerifiedFlag ? _vm.WHHandoverOTPVerifiedFlag : '-') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("RTO Profarma")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.rtoProfarma) ? _c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.rtoProfarma,
      "download": ""
    }
  }, [_vm._v("Download")])]) : _vm._e(), _vm._v(" "), (!_vm.rtoProfarma) ? _c('span', [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Flagged Deliveries Images")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.summeryData.ShipmentStatus == 'WHHandover' && _vm.flaggedImages.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.flaggedImages), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.flaggedImages, i, 'Flagged Deliveries Images')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": img,
        "alt": "-"
      }
    })])
  })) : _c('span', [_vm._v(" - ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper wide-item2"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("WH Handover Dispute Proof by Client (Images/Videos)")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [(_vm.STDassets && _vm.STDassets.clientImages) ? _c('div', {
    staticClass: "image-grid",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "2px",
      "align-items": "center"
    }
  }, _vm._l((_vm.STDassets.clientImages), function(img, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "gap": "2px"
      }
    }, [(img.attachment && !img.broken) ? _c('img', {
      staticClass: "main-image img-fluid",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "object-fit": "cover",
        "cursor": "pointer",
        "border-radius": "4px"
      },
      attrs: {
        "src": img.attachment,
        "alt": "Image Preview"
      },
      on: {
        "click": function($event) {
          _vm.openPreview(img.attachment, 'image')
        },
        "error": function($event) {
          img.broken = true
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [(img.attachment && img.broken) ? _c('a', {
      staticClass: "media-link",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "font-size": "14px"
      },
      attrs: {
        "href": img.attachment,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\n                      Image " + _vm._s(index + 1) + "\n                    ")]) : _vm._e(), _vm._v(" "), (index < _vm.STDassets.clientImages.length - 1 && _vm.STDassets.clientImages.slice(index + 1).some(function (i) { return i.attachment && i.broken; })) ? _c('span', {
      staticStyle: {
        "margin": "0 2px"
      }
    }, [_vm._v("|")]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.STDassets && _vm.STDassets.videourl) ? _c('div', {
    staticClass: "video-grid",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "2px",
      "margin-top": "12px"
    }
  }, _vm._l((_vm.STDassets.videourl), function(vid, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "gap": "2px"
      }
    }, [(vid.UnboxingVideoProof1 && !vid.broken) ? _c('video', {
      staticClass: "inv-video-preview",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "object-fit": "cover",
        "cursor": "pointer",
        "border-radius": "4px"
      },
      attrs: {
        "src": vid.UnboxingVideoProof1,
        "controls": "",
        "muted": ""
      },
      on: {
        "click": function($event) {
          _vm.openPreview(vid.UnboxingVideoProof1, 'video')
        },
        "error": function($event) {
          vid.broken = true
        }
      }
    }, [_vm._v("\n                      Your browser does not support the video tag.\n                    ")]) : _vm._e(), _vm._v(" "), (vid.UnboxingVideoProof1 && vid.broken) ? _c('a', {
      staticClass: "media-link",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "font-size": "14px"
      },
      attrs: {
        "href": vid.UnboxingVideoProof1,
        "target": "_blank",
        "rel": "noopener noreferrer",
        "download": ("proof-video-" + (index + 1) + ".mp4")
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadVideo(vid.UnboxingVideoProof1, ("proof-video-" + (index + 1) + ".mp4"))
        }
      }
    }, [_vm._v("\n                      Video\n                    ")]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), (_vm.previewUrl) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.closePreview
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.previewType === 'image') ? _c('img', {
    staticClass: "preview-media",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.previewType === 'video') ? _c('video', {
    staticClass: "preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": "",
      "autoplay": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closePreview
    }
  }, [_vm._v("×")])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.Disabled) ? _c('section', {
    staticClass: "section",
    attrs: {
      "id": "section8"
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "summary-table"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', [_vm._l((_vm.weightVariance), function(data, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.convertDate(data.CapturedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.VolumetricWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubList[data.HubId] ? _vm.hubList[data.HubId] : '-'))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "img-links",
      on: {
        "click": function($event) {
          _vm.showMedia(_vm.weightVariance, i, 'Weight Variance Images')
        }
      }
    }, [_vm._v(" Image")])])])
  }), _vm._v(" "), (_vm.weightVariance.length === 0) ? _c('tr', [_c('td', {
    staticClass: "no-data",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No data available")])]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.isDataFound && _vm.Disabled) ? _c('div', {
    staticClass: "log-wrapper",
    attrs: {
      "id": "section9"
    }
  }, [_c('h5', [_vm._v("Shipment Journey")]), _vm._v(" "), _c('table', {
    staticClass: "log-table mt-3"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_vm._l((_vm.disputeDataLog), function(data, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubList[data.CurrentLocation] ? _vm.hubList[data.CurrentLocation] : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.actionNameList[data.Actionstatuscode] ? _vm.actionNameList[data.Actionstatuscode] : data.Process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments ? data.Comments : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy ? data.CreatedBy : '-'))])])
  }), _vm._v(" "), (_vm.disputeDataLog.length === 0) ? _c('tr', [_c('td', {
    staticClass: "no-data",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No data available")])]) : _vm._e()], 2)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-wrapper",
    attrs: {
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [
    [_c('h5', {
      staticClass: "modal-title"
    }, [_vm._v(_vm._s(_vm.modalHeader))]), _vm._v(" "), (_vm.images.length > 0) ? _c('span', {
      staticClass: "download-btn"
    }, [_c('a', {
      attrs: {
        "href": _vm.images[_vm.currentImageIndex].ImageUrl ? _vm.images[_vm.currentImageIndex].ImageUrl : _vm.images[_vm.currentImageIndex],
        "download": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "close",
      attrs: {
        "aria-label": "Close"
      },
      on: {
        "click": _vm.closeImage
      }
    }, [_vm._v("X")])], _vm._v(" "), (_vm.images.length > 0) ? _c('div', [_c('div', {
      staticClass: "modal-content text-center"
    }, [(_vm.isVideoFile(_vm.images[_vm.currentImageIndex])) ? _c('video', {
      staticClass: "inv-video-preview",
      attrs: {
        "src": _vm.images[_vm.currentImageIndex],
        "type": "video/mp4",
        "controls": ""
      }
    }, [_vm._v("\n          Your browser does not support the video tag.\n        ")]) : _c('img', {
      staticClass: "main-image img-fluid",
      attrs: {
        "src": _vm.images[_vm.currentImageIndex].ImageUrl ? _vm.images[_vm.currentImageIndex].ImageUrl : _vm.images[_vm.currentImageIndex]
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "carousel-control prev",
      on: {
        "click": _vm.prevImage
      }
    }, [_c('span', {
      staticClass: "arrow"
    }, [_vm._v("❮")])]), _vm._v(" "), _c('button', {
      staticClass: "carousel-control next",
      on: {
        "click": _vm.nextImage
      }
    }, [_c('span', {
      staticClass: "arrow"
    }, [_vm._v("❯")])]), _vm._v(" "), _c('div', {
      staticClass: "thumbnail-container mt-3 text-center"
    }, _vm._l((_vm.images), function(image, index) {
      return _c('img', {
        key: index,
        staticClass: "thumbnail",
        class: {
          active: index === _vm.currentImageIndex
        },
        attrs: {
          "src": image.ImageUrl ? image.ImageUrl : image
        },
        on: {
          "click": function($event) {
            _vm.currentImageIndex = index
          }
        }
      })
    }))]) : _vm._e()
  ], 2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.searchLoading,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Shipment Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }, [_vm._v("Calc LHWT")]), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  }, [_vm._v("-")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Manifestation Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Customer / Vendor Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Customer / Vendor Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Pickup Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-data"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _c('th', [_vm._v("Expected Answers by Client")]), _vm._v(" "), _c('th', [_vm._v("SR Answer")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Transit")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper wide-item4"
  }, [_c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Internal Investigation Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {}, [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Current Location")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Action Taken")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Investigation Images / Videos ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h5', [_vm._v("Weight Variance")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date and Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Weight (in KG)")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Images")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Created By")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2447aea","hasScoped":true}!./src/views/components/summeryPageNew/summeryPageNew.component.html
// module id = 631
// module chunks = 1